import { render, staticRenderFns } from "./ComingSoonFlag.vue?vue&type=template&id=2315aa10&scoped=true"
import script from "./ComingSoonFlag.vue?vue&type=script&lang=js"
export * from "./ComingSoonFlag.vue?vue&type=script&lang=js"
import style0 from "./ComingSoonFlag.vue?vue&type=style&index=0&id=2315aa10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2315aa10",
  null
  
)

export default component.exports